import React from 'react';
import PropTypes from 'prop-types';
import UISvgIcon from '@material-ui/core/SvgIcon';
import pure from 'recompose/pure';
import withRoot from 'hoc/withRoot';

const styles = {
  common: {
    display: 'flex',
  },
  sizes: {
    xxsmall: {
      height: 13,
      width: 13,
    },
    xsmall: {
      height: 20,
      width: 20,
    },
    small: {
      height: 25,
      width: 25,
    },
    medium: {
      height: 40,
      width: 40,
    },
    large: {
      height: 50,
      width: 50,
    },
    xlarge: {
      height: 100,
      width: 100,
    },
    logo: {
      height: 20,
      width: 30,
    },
  },
  border: (color, { colors }) => {
    return {
      border: `1px solid ${color || colors.iconColor}`,
      borderRadius: '2rem',
    };
  },
  button: {
    verticalAlign: 'middle',
  },
  social: height => ({
    position: 'absolute',
    right: 10,
    top: '50%',
    marginTop: -height / 2,
  }),
};

const SvgIcon = (
  { size, bordered, children, color, button, social, style, ...props },
  { classes }
) => (
  <UISvgIcon
    {...props}
    style={{
      ...(button || styles.common),
      ...styles.sizes[size],
      ...(bordered && styles.border(color, classes)),
      ...(button && styles.button),
      ...(social && styles.social(styles.sizes[size].height)),
      ...style,
    }}
  >
    {children}
  </UISvgIcon>
);

SvgIcon.propTypes = {
  size: PropTypes.oneOf(Object.keys(styles.sizes)),
  bordered: PropTypes.bool,
  button: PropTypes.bool,
  social: PropTypes.bool,
  color: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
};

SvgIcon.defaultProps = {
  size: 'small',
};

export default pure(withRoot(SvgIcon));
